var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM5.72761 1.8181C5.62715 1.41625 5.21994 1.17193 4.8181 1.27239C4.41625 1.37285 4.17193 1.78006 4.27239 2.1819L5.27239 6.1819C5.30536 6.31378 5.37355 6.43421 5.46967 6.53033L7.46967 8.53033C7.76256 8.82322 8.23744 8.82322 8.53033 8.53033C8.82322 8.23744 8.82322 7.76256 8.53033 7.46967L6.67722 5.61656L5.72761 1.8181Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon-time.d0c3db4ccdba1893a7b3e999b4aaec3d.svg";
export { ForwardRef as ReactComponent };